import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, CanActivate } from '@angular/router';
import { AuthGuardService as DomainCheck} from './services/auth-guard/auth-guard.service';

const routes: Routes = [

  {
    path: 'casino',
    loadChildren: () => import('./tabs/tab-casino/tab-casino.module').then(m => m.TabCasinoPageModule),
    canActivate : [DomainCheck]
  },
  {
    path: 'livedealer',
    loadChildren: () => import('./tabs/tab-livedealer/tab-livedealer.module').then(m => m.TabLiveDealerPageModule),
    canActivate : [DomainCheck]
  },
  {
    path: 'launcher',
    loadChildren: () => import('./tabs/tab-game/tab-game.module').then(m => m.TabGamePageModule),
    canActivate : [DomainCheck]
  },
  {
    path: 'promotions',
    loadChildren: () => import('./tabs/tab-promotions/tab-promotions.module').then(m => m.TabPromotionsPageModule),
    canActivate : [DomainCheck]
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tab-landing/tab-landing.module').then(m => m.TabLandingPageModule)
  },
  {
    path: 'webview',
    loadChildren: () => import('./tabs/tab-webview/tab-webview.module').then(m => m.TabWebviewPageModule),
    canActivate : [DomainCheck]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {}
